import { ExternalLink } from "lucide-react";
import { reviewSummary, reviewPlatforms } from "@/data/reviews";
import { Stars } from "@/components/site/ReviewsBlock";

const shown = ["Google", "Trustoo", "VerhuisOffertes"];

export function ReviewBar({ tone = "default" }: { tone?: "default" | "muted" }) {
  const platforms = reviewPlatforms.filter((p) => shown.includes(p.name));

  return (
    <div className={tone === "muted" ? "bg-muted" : "bg-background"}>
      <div className="container-page">
        <div className="flex items-center gap-4 overflow-x-auto border-b border-border py-4 sm:gap-6">
          {reviewSummary ? (
            <div className="flex shrink-0 items-center gap-2">
              <Stars rating={Math.round(reviewSummary.rating)} />
              <span className="whitespace-nowrap text-sm font-bold text-secondary">
                {reviewSummary.rating.toString().replace(".", ",")}/5
              </span>
              <span className="whitespace-nowrap text-xs text-muted-foreground">
                uit {reviewSummary.count} reviews
              </span>
            </div>
          ) : null}

          <div className="flex shrink-0 items-center gap-3 sm:gap-4">
            {platforms.map((p) => (
              <a
                key={p.name}
                href={p.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex shrink-0 items-center gap-1.5 rounded-full border border-border px-3 py-1.5 text-xs font-bold text-secondary transition hover:border-brand hover:text-brand"
              >
                <span>{p.name}</span>
                <span className="text-brand">{p.score}</span>
                <span className="font-medium text-muted-foreground">{p.count}</span>
                <ExternalLink className="size-3" aria-hidden />
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
